export enum Paths {
  GetBizDomain = '/api/biz/list',
  UpdateBizDomain = '/api/biz/item',
  GetEduDomain = '/api/edu/list',
  UpdateEduDomain = '/api/edu/item',
  GetEduEmail = '/api/edu/emails',
  UpdateEduEmail = '/api/edu/emails',
  GetEduSchool = '/api/edu/schools',
  SignOut = '/oauth/signout'
}
